
export default function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Address Changed',
        message: 'Your subscription(s) will ship to the following address on your next shipment date.',
        nextShipment: 'Next Shipment:',
        shippingAddress: 'Shipping Address',
        gotIt: 'Got It'
    };

    return resources[label];
}
